import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ParentComponentApi} from '../profile/profile.component';
import {DxFormComponent} from 'devextreme-angular';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http'; 
import { Configuration } from '../../../app.constants';
import {HelperService} from '../../../shared/services/helper.service';
import { compilePipeFromMetadata } from '@angular/compiler';
//import { BankdetailsformService,BankDetails } from '../../services/bankdetailsform.service';   
import {PhysicalcertificateService,personalinformation,BloodGroup} from '../../services/physicalcertificate.service'
import { ImageUploadService } from '../../../shared/services/image-upload.service';
//import { CommondocumentsService, preCommonDocumentsInfo, Documents, UsertDetailsStatus } from '../../services/commondocuments.service'

@Component({
  selector: 'physicalcertificate',
  templateUrl: './physicalcertificate.component.html',
  styleUrls: ['./physicalcertificate.component.scss'],
  providers:[HelperService,PhysicalcertificateService]
})
export class PhysicalcertificateComponent implements OnInit {

  @ViewChild(DxFormComponent) PhysicalcertificateForm: DxFormComponent;
  PhysicalCertData:personalinformation;

  value: any[] = [];
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;

  showButtons:boolean=false;
  loadIndicatorVisible:boolean=false;
  readOnly: boolean = false;
  EnglishSpeedDis : boolean = false;
  MarathiSpeedDis : boolean = false;
  StenoSpeedDis : boolean = false;
  MSCITCertDis : boolean = false;
  SexCodeDis : boolean = false;
  StudentExistsDis : boolean = false;
  documentId: string;
  
  isValid: boolean; 
  SaveBtnDisabled: boolean;
  DeleteBtnDisabled :boolean;
  //PhysicalCertData:BankDetails;
  errorMessage: string[] = new Array(); 
  dataSource:any;
  DocumentsList:any;
  BloodGroupList:any;
  LanguageLabel:any;
  PreStudentPhyInfoID:0;
  namePattern: any = /^[^0-9]+$/;
  Pattern1: any =/^[^<>]+$/;

  maxYear=0;
  BirthYear=0;
  ChestMinLim = 0;
  MotherTongueType = [  
    { MotherTongueTypeID: "N", MotherTongueTypeName: 'No' },
    { MotherTongueTypeID: "Y", MotherTongueTypeName: 'Yes' }
  ];
  EnglishType = [   
    { EnglishTypeID: "N", EnglishTypeName: 'No' },
    { EnglishTypeID: "Y", EnglishTypeName: 'Yes' }
  ];
  StenoType = [   
    { StenoTypeID: "N", StenoTypeName: 'No' },
    { StenoTypeID: "Y", StenoTypeName: 'Yes' },
  ];
  MSCIT = [
    { MSCITID: "N", MSCITName: 'No' },
    { MSCITID: "Y", MSCITName: 'Yes' }   
  ];
  MedicalCert = [
    { MedicalCertID: "N", MedicalCertName: 'No' },
    { MedicalCertID: "Y", MedicalCertName: 'Yes' }   
  ];


 
  
  constructor(private http:HttpClient,
    private router: Router,private route: ActivatedRoute, 
    private PhysicalcertificateService:PhysicalcertificateService, 
    private configuration: Configuration,private helperService:HelperService, 
    private imageService: ImageUploadService
    ) { 
      this.maxYear = (new Date()).getFullYear();
    }


  ngOnInit() {
    this.LanguageLabel =this.configuration.LanguageLabel[0];
    this.clearData();
     

    this.PhysicalcertificateService.GetBasicBloodGroupsList(0) 
    .subscribe((data: BloodGroup[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => {  
        this.BloodGroupList=this.dataSource; 
    });   
    
    this.PhysicalcertificateService.GetStudentInformationForPhysicalInfoStudentPortal(this.configuration.CollegeID, 0, 0, 0, this.configuration.AcademicInstanceID, 0, this.configuration.StudentID) 
    .subscribe((data: personalinformation[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger        
        if(this.dataSource.length>0){
            this.PhysicalCertData=this.dataSource[0]; 
            this.PhysicalCertData.MSCITCertYear=this.dataSource[0].MSCITCertYear;
            this.PhysicalCertData.BirthYear=this.dataSource[0].BirthYear;
            this.BirthYear = this.dataSource[0].BirthYear;
            if(this.dataSource[0].MSCIT == 'Y'){
              this.BirthYear = this.dataSource[0].BirthYear;
            }
            else{
              this.BirthYear = 0;
            }
            if(this.dataSource[0].StudentSexCode == 'M'){
              this.SexCodeDis = false;
              this.ChestMinLim = 30;
            }
            else{
              this.SexCodeDis = true;
              this.ChestMinLim = 0;
            } 
            if(this.dataSource[0].StudentCourseID > 0){
              this.SaveBtnDisabled = false;    
              if(this.dataSource[0].PreStudentPhyInfoID > 0){     
                this.DeleteBtnDisabled = false;
              }
              else{     
                this.DeleteBtnDisabled = true;
              }
                   
              this.showButtons = true;               
            }
            else{
              this.showButtons = false;          
              this.SaveBtnDisabled = true;       
              this.DeleteBtnDisabled = true;
              this.helperService.showWarningMessage("You are not able to fill Physical & Other Certificate info");
              //this.cancelClick()
            }
            if(this.dataSource[0].PreStudentPhyInfoID > 0){
              this.PreStudentPhyInfoID = this.dataSource[0].PreStudentPhyInfoID ;
              if(this.PreStudentPhyInfoID  > 0 ){
                this.GetPhysicalCerData(); 
              }
            }
        }
        else{
          this.SaveBtnDisabled = true;   
          this.DeleteBtnDisabled = true;
        }
    });  
  }
  getdata() {    
    if (this.PreStudentPhyInfoID  == null || this.PreStudentPhyInfoID  == undefined) {
      this.PreStudentPhyInfoID  = 0;
      return false;
    }
    this.PhysicalcertificateService.GetPreStudentInformationForPhysicalInfoDocument( this.PreStudentPhyInfoID , this.configuration.StudentID) 
    .subscribe((data: personalinformation[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger
        if(this.dataSource.length>0){
         // this.PhysicalCertData=this.dataSource[0]; 
          if(this.dataSource[0].DocumentsList.length>0){
            this.DocumentsList=this.dataSource[0].DocumentsList;  
            if(this.dataSource[0].PreStudentPhyInfoID > 0){
              this.showButtons = true;    
            }            
          }         
        }
      });  
  }
  GetPhysicalCerData()
  {     
    if (this.PreStudentPhyInfoID  == null || this.PreStudentPhyInfoID  == undefined) {
      this.PreStudentPhyInfoID  = 0;
      return false;
    }
    this.PhysicalcertificateService.GetPreStudentInformationForPhysicalInfoDocument( this.PreStudentPhyInfoID , this.configuration.StudentID) 
    .subscribe((data: personalinformation[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger
        if(this.dataSource.length>0){
          this.PhysicalCertData=this.dataSource[0]; 
          this.PhysicalCertData.MSCITCertYear=this.dataSource[0].MSCITCertYear;
          this.PhysicalCertData.BirthYear=this.dataSource[0].BirthYear;
          if(this.dataSource[0].MSCIT == 'Y'){
            this.BirthYear = this.dataSource[0].BirthYear;
          }
          else{
            this.BirthYear = 0;
          }
          if(this.dataSource[0].DocumentsList.length>0){
          this.DocumentsList=this.dataSource[0].DocumentsList; 
          if(this.dataSource[0].PreStudentPhyInfoID > 0){
            this.showButtons = true;    
          }            
          }         
        }
      });  
  } 
  cancelClick(){
    this.SaveBtnDisabled = false;
    this.errorMessage=[];
    this.router.navigate(['/login-form']);
  }
  
  saveRecord() {
    if ((this.configuration.StudentID==null)||(this.configuration.StudentID==0))
    {
      this.helperService.showSuccessMessage("Blank Student Id Not Allowed.");
      return false;    
    }

    if (this.PhysicalCertData.Studentht == null || this.PhysicalCertData.Studentht == 0 || this.PhysicalCertData.Studentht == undefined) {
      this.helperService.showWarningMessage("Enter Student Height")
      return false;
    }
    if (this.PhysicalCertData.Studentwt == null || this.PhysicalCertData.Studentwt == 0 || this.PhysicalCertData.Studentwt == undefined) {
      this.helperService.showWarningMessage("Enter Student Weight")
      return false;
    }
    if (this.PhysicalCertData.Studentchest == null || this.PhysicalCertData.Studentchest == 0  || this.PhysicalCertData.Studentchest == undefined) {
      this.PhysicalCertData.Studentchest = 0;
    }
    if (this.PhysicalCertData.BloodGroupID == null || this.PhysicalCertData.BloodGroupID == undefined) {
      this.PhysicalCertData.BloodGroupID = 0;
    }
    if (this.PhysicalCertData.MotherTongue == null || this.PhysicalCertData.MotherTongue == undefined) {
      this.PhysicalCertData.MotherTongue = "";
    }
    
    if (this.PhysicalCertData.TypingMotherTongue == null || this.PhysicalCertData.TypingMotherTongue == undefined) {
      this.helperService.showWarningMessage("Select MotherTongue Typing")
      return false;
    }
    else if (this.PhysicalCertData.TypingMotherTongue == 'Y'){
      if (this.PhysicalCertData.TypingMotherTongueSpeed == null || this.PhysicalCertData.TypingMotherTongueSpeed == undefined) {
        this.helperService.showWarningMessage("Select MotherTongue Typing Speed")
        return false;
      }
    }
    else{
      this.PhysicalCertData.TypingMotherTongueSpeed = 0;
    }
 
    
    if (this.PhysicalCertData.TypingEnglish == null || this.PhysicalCertData.TypingEnglish == undefined) {
      this.helperService.showWarningMessage("Select English Typing")
      return false;
    }
    else if (this.PhysicalCertData.TypingEnglish == 'Y'){
      if (this.PhysicalCertData.TypingEnglishSpeed == null || this.PhysicalCertData.TypingEnglishSpeed == undefined) {
        this.helperService.showWarningMessage("Select English Typing Speed")
        return false;
      }
    }
    else{
      this.PhysicalCertData.TypingEnglishSpeed = 0;
    }
 
    if (this.PhysicalCertData.TypingSteno == null || this.PhysicalCertData.TypingSteno == undefined) {
      this.helperService.showWarningMessage("Select Steno Typing")
      return false;
    }
    else if (this.PhysicalCertData.TypingSteno == 'Y'){
      if (this.PhysicalCertData.StenoSpeed == null || this.PhysicalCertData.StenoSpeed == undefined) {
        this.helperService.showWarningMessage("Select Steno Typing Speed")
        return false;
      }
    }
    else{
      this.PhysicalCertData.StenoSpeed = 0;
    }




    if (this.PhysicalCertData.MSCIT == null || this.PhysicalCertData.MSCIT == ""  || this.PhysicalCertData.MSCIT == undefined) {
      this.helperService.showWarningMessage("Select MSCIT Certificate")
      return false;
    }
    else if (this.PhysicalCertData.MSCIT == 'Y'){
      if (this.PhysicalCertData.MSCITCertYear == null  || this.PhysicalCertData.MSCITCertYear == 0 || this.PhysicalCertData.MSCITCertYear == undefined) {
        this.helperService.showWarningMessage("Enter MSCIT Year")
        return false;
      }
      if (this.PhysicalCertData.MSCITCertYear < 1900){
        this.helperService.showWarningMessage("Invalid MSCIT Year")
        return false;
      }
      if (this.PhysicalCertData.MSCITCertYear.toLocaleString.length > 0){
        this.helperService.showWarningMessage("Invalid MSCIT Year")
        return false;
      }
    }
    else{
      this.PhysicalCertData.MSCITCertYear = 0;
      this.PhysicalCertData.MSCITCertGrade = "";
    }


    if (this.PhysicalCertData.Medical == null || this.PhysicalCertData.Medical == "" || this.PhysicalCertData.Medical == undefined) {
      this.helperService.showWarningMessage("Select Medical Certificate.")
      return false;
    }

    if (this.PhysicalCertData.PreStudentPhyInfoID == null || this.PhysicalCertData.PreStudentPhyInfoID == 0 || this.PhysicalCertData.PreStudentPhyInfoID == undefined) {
      this.PhysicalCertData.PreStudentPhyInfoID = 0;
    }

    this.PhysicalCertData.CreatedLoginID = this.configuration.CreatedLoginID;
    this.PhysicalCertData.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.PhysicalCertData.AcademicInstanceID = this.configuration.AcademicInstanceID;

    this.isValid = this.PhysicalcertificateForm.instance.validate().isValid;
    if(this.isValid == true) {  
      this.errorMessage=[];
      debugger; 
      if(this.PhysicalCertData.PreStudentPhyInfoID > 0 ){
        this.PhysicalCertData.StudentID=this.configuration.StudentID;
       this.PhysicalcertificateService.UpdatePhysicalInfo(this.PhysicalCertData)
         .subscribe(value => {
           this.onSuccessSave();
         },
           err => {
             this.errorMessage=this.helperService.getErrorMessage(err);
             this.helperService.showSuccessMessage("Not Saved.");    
           },
           () => {
           
           });

      }
      else{
        this.PhysicalCertData.StudentID=this.configuration.StudentID;
       this.PhysicalcertificateService.PostInsertPhysicalInfo(this.PhysicalCertData)
         .subscribe(value => {
           this.onSuccessSave();
         },
           err => {
             this.errorMessage=this.helperService.getErrorMessage(err);
             this.helperService.showSuccessMessage("Not Saved.");    
           },
           () => {
           
           });

      }
    }
  }

  
  deleteRecord() {
    this.PhysicalCertData.StudentID=this.configuration.StudentID;
    this.PhysicalCertData.UpdatedLoginID = this.configuration.UpdatedLoginID;
    this.PhysicalCertData.AcademicInstanceID = this.configuration.AcademicInstanceID;
    
   this.PhysicalcertificateService.PostDeletePhysicalInfo(this.PhysicalCertData)
     .subscribe(value => {
      this.helperService.showSuccessMessage("Deleted Successfully."); 
      this.getPhysicalDetailData();
      this.GetPhysicalCerData();
      this.PhysicalCertData.PreStudentPhyInfoID  = 0; 
      /* this.OtherCoursesInfoData.OthCourseName           =  "";
       this.OtherCoursesInfoData.OthCourseAuthority      =  "";
       this.OtherCoursesInfoData.OthCourseYear           =  "";
       this.OtherCoursesInfoData.OthCourseGrade          =  "";
       this.OtherCoursesInfoData.OthCourseCert           =  "";  */ 
       this.DeleteBtnDisabled = true;
     },
       err => {
         this.errorMessage=this.helperService.getErrorMessage(err);
         this.helperService.showSuccessMessage("Not Deleted.");    
       },
       () => {
       
       });
  }

  getPhysicalDetailData(){
    
    this.PhysicalcertificateService.GetStudentInformationForPhysicalInfoStudentPortal(this.configuration.CollegeID, 0, 0, 0, this.configuration.AcademicInstanceID, 0, this.configuration.StudentID) 
    .subscribe((data: personalinformation[]) => this.dataSource = data,
    err => {
      var error = this.helperService.getErrorMessage(err)
      alert("error");
      },
      () => { debugger        
        if(this.dataSource.length>0){
            this.PhysicalCertData=this.dataSource[0]; 
            this.PhysicalCertData.MSCITCertYear=this.dataSource[0].MSCITCertYear;
            this.PhysicalCertData.BirthYear=this.dataSource[0].BirthYear;
            this.BirthYear = this.dataSource[0].BirthYear;
            if(this.dataSource[0].MSCIT == 'Y'){
              this.BirthYear = this.dataSource[0].BirthYear;
            }
            else{
              this.BirthYear = 0;
            }
            if(this.dataSource[0].StudentSexCode == 'M'){
              this.SexCodeDis = false;
              this.ChestMinLim = 30;
            }
            else{
              this.SexCodeDis = true;
              this.ChestMinLim = 0;
            } 
            if(this.dataSource[0].StudentCourseID > 0){
              this.SaveBtnDisabled = false;    
              if(this.dataSource[0].PreStudentPhyInfoID > 0){     
                this.DeleteBtnDisabled = false;
              }
              else{     
                this.DeleteBtnDisabled = true;
              }
                   
              this.showButtons = true;               
            }
            else{
              this.showButtons = false;          
              this.SaveBtnDisabled = true;       
              this.DeleteBtnDisabled = true;
              this.helperService.showWarningMessage("You are not able to fill Physical & Other Certificate info");
              //this.cancelClick()
            }
            if(this.dataSource[0].PreStudentPhyInfoID > 0){
              this.PreStudentPhyInfoID = this.dataSource[0].PreStudentPhyInfoID ;
              if(this.PreStudentPhyInfoID  > 0 ){
                this.GetPhysicalCerData(); 
              }
            }
        }
        else{
          this.SaveBtnDisabled = true;   
          this.DeleteBtnDisabled = true;
        }
    });  
  }
  clearData(){
   /*  this.PhysicalCertData={
      StudentID:this.configuration.StudentID,  
      BankBranchName:"", 
      IFSCCode:"",
      AccountNo: "",
      }
      this.errorMessage=[]; */
  }
  onSuccessSave() {
    this.getPhysicalDetailData() ;
    this.getdata() ;
    this.DeleteBtnDisabled = true;
    this.helperService.showSuccessMessage("Saved Successfully.");   
  }
  
  TypingEnglishChange(){ 
    if (this.PhysicalCertData.TypingEnglish == null || this.PhysicalCertData.TypingEnglish == undefined) { 
      return false;
    }
    if(this.PhysicalCertData.TypingEnglish == 'Y'){
      this.EnglishSpeedDis = false;
    }
    else{
      this.PhysicalCertData.TypingEnglishSpeed =  0 ;
      this.EnglishSpeedDis = true;
    }
  }
  
  TypingMarathiChange(){ 
    if (this.PhysicalCertData.TypingMotherTongue == null || this.PhysicalCertData.TypingMotherTongue == undefined) { 
      return false;
    }
    if(this.PhysicalCertData.TypingMotherTongue == 'Y'){
      this.MarathiSpeedDis = false;
    }
    else{
      this.PhysicalCertData.TypingMotherTongueSpeed =  0 ;
      this.MarathiSpeedDis = true;
    }
  }
  
  
  TypingStenoChange(){
    if(this.PhysicalCertData.TypingSteno == 'Y'){
      this.StenoSpeedDis = false;
    }
    else{
      this.PhysicalCertData.StenoSpeed =  0 ;
      this.StenoSpeedDis = true;
    }
  }

  
  
  MSCITCertChange(){
    if(this.PhysicalCertData.MSCIT == 'Y'){
      this.MSCITCertDis = false;
      this.BirthYear = this.PhysicalCertData.BirthYear;
    }
    else{
      this.PhysicalCertData.MSCITCertYear =  0 ;
      this.PhysicalCertData.MSCITCertGrade =  "" ;
      this.MSCITCertDis = true;
      this.BirthYear = 0;
    }
  }

  
  handleFileUpload(messageResponse: string) {
    this.helperService.showSuccessMessage("File uploaded successfully.");
    this.getdata();
  }

  handleFileUploadError() {
    this.helperService.showSuccessMessage("File upload not successful.");
  }

  
  viewPdfDocument(data) {
    debugger
    if (data.key.CertPath.length > 0) {
      this.documentId = data.key.CertId;
      this.urlDoc = data.key.CertPath ;
      this.openWindow();
    }
  }
  
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  popupHiding(e) {
    this.errorMessage = [];
  };



  onEditorPreparing(e) {
    if (e.parentType === "dataRow")
    {
      if (e.dataField === "chk")
      {
       
          e.editorOptions.readOnly = true;
        
      }
    }
  }
  
  removeDocument(data) {
    if (data.key.CertPath.length > 0) {
      var deleteDocument = {
        "PreStudentPhyInfoID": data.key.PreStudentPhyInfoID,
        "UpdatedLoginID": this.configuration.UpdatedLoginID,
        "StudentID": this.configuration.StudentID,
        "CertId": data.key.CertId,
      }
     debugger;
      this.PhysicalcertificateService.PostRemovedPhyInfoCertificate(deleteDocument)    
          .subscribe(value => {
           this.getdata();
           this.helperService.showSuccessMessage("File Deleted Successfully.");
        },
          error => {
            alert(error);
          },
          () => {
           
          });
    }
    
  }
}